export enum StowageRuleId {
    OxygenSensitiveProductsSoftRule = 8, // Rule configured in the Commodity Book - DO NOT change this ID
    BasfHmdSoftRule = 14, // Rule configured in the Commodity Book - DO NOT change this ID

    BlockedTankSoftRule = 100,
    CargoNegativeNominatedWeightHardRule = 101,
    CargoNegativeStowedWeightHardRule = 102,
    FillRatioOver98PercentSoftRule = 103,
    Ibc15_14SoftRule = 104,
    Ibc16_6_3_or_4HardRule = 105,
    IllegalComminglingHardRule = 106,
    IncompatibleHeatingMediumSoftRule = 107,
    IncompatibleIbcShipTypeHardRule = 108,
    IncompatibleIbcTankTypeHardRule = 109,
    IncompatiblePressureVacuumSettingsHardRule = 110,
    InsufficientHeatingCapacitySoftRule = 111,
    MaxAdjacentTemperatureHardRule = 112,
    MaxAdjacentTemperatureSoftRule = 113,
    PropyleneOxideHardRule = 114,
    PropyleneOxideSoftRule = 115,
    TankVolumeCapacityExceededForCargoIbcShipTypeOneHardRule = 116,
    TankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule = 117,
    TankVolumeCapacityExceededHardRule = 118,
    TankWeightCapacityExceededHardRule = 119,
    UnstowedCargoOperationInDepartedCallHardRule = 120,
    UsedCookingOilSoftRule = 121,
    Ibc15_11_3SoftRule = 122,
    Ibc15_12_3HardRule = 123,
    UscgCompatibilityHardRule = 126,
    Type2KCommodityHardRule = 127,
    TankMaxLitreWeightExceededHardRule = 128,
    TankMaxLitreWeightExceededSoftRule = 129,
    ManualCargoOperationInDepartedCallSoftRule = 130,
    CargoNegativeNominatedWeightInCallHardRule = 131,
    CoatingCompatibilitySoftRule = 132,
    CoatingCompatibilityHardRule = 133,
    StowedWeightExceedsNominatedWeightSoftRule = 134,
    ContractWeightOverrideInDepartedCallHardRule = 135,
    BlockedTankMissingCallSoftRule = 136,
    UscgSequenceDependencySoftRule = 137,
}
